import { ChangeDetectionStrategy, Component, HostListener, Inject, Input } from '@angular/core';

@Component({
	selector: 'jsg-sticky-toolbar',
	templateUrl: './sticky-toolbar.component.html',
	styleUrls: ['./sticky-toolbar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyToolbarComponent {
	@Input() caption: string;
	@Input() backgroundColor = '#ffffff';

	isDesktop = false;

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.isDesktop = this.$window.innerWidth > 400;
	}

	constructor(@Inject('window') private $window: Window) {
		this.onResize();
	}
}
